import { useCallback } from 'react';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import type { BookSalesDemoSource } from '../lib/sources';

import { useBookSalesDemoStore } from './useBookSalesDemoStore';

export const useOpenBookSalesDemo = () => {
  const open = useBookSalesDemoStore((state) => state.open);

  return useCallback(
    (source: BookSalesDemoSource, sourceText: string) => {
      MixpanelEvents.bookSalesDemoOpened({ source, sourceText });
      open({ source, sourceText });
    },
    [open],
  );
};
